import { Dispatch } from 'react';
import { get, put } from 'communication/httpClient';

import { SYNCING, SET_SETTINGS, RESET, SET_ERROR } from './actionTypes';
import { IWicSettingsActions, IWICSettingAction } from './types';

export const getActions = (dispatch: Dispatch<IWICSettingAction>): IWicSettingsActions => ({
  loadSettings: async () => {
    dispatch({
      type: SYNCING,
    });
    const { data, error } = await get('/api/wic-settings');
    if (data) {
      dispatch({
        type: SET_SETTINGS,
        payload: data,
      });
    } else if (error) {
      dispatch({
        type: SET_ERROR,
        payload: error,
      });
    }
  },
  setSettings: async (settings) => {
    dispatch({
      type: SYNCING,
    });
    const { data, error } = await put('/api/wic-settings', settings);
    if (data || !error) {
      dispatch({
        type: SET_SETTINGS,
        payload: settings,
      });
    } else if (error) {
      dispatch({
        type: SET_ERROR,
        payload: error,
      });
    }
  },
  reset: () => {
    dispatch({
      type: RESET,
    });
  },
});
